import { FaviconConfig, FaviconServiceInterface } from '../types/favicon';

class FaviconService implements FaviconServiceInterface {
  private static instance: FaviconService;
  private currentConfig: FaviconConfig = {};

  static getInstance(): FaviconService {
    if (!FaviconService.instance) {
      FaviconService.instance = new FaviconService();
    }
    return FaviconService.instance;
  }

  // 현재 파비콘 설정을 저장
  setCurrentConfig(config: FaviconConfig): void {
    this.currentConfig = { ...config };
  }

  getCurrentConfig(): FaviconConfig {
    return { ...this.currentConfig };
  }

  // 파비콘 URL 생성
  buildFaviconUrl(params: FaviconConfig): string {
    const apiUrl = process.env.REACT_APP_CAMPUS_API_BASE_URL || '';
    const queryString = new URLSearchParams(
      Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null) {
          acc[key] = String(value);
        }
        return acc;
      }, {} as Record<string, string>)
    ).toString();
    
    return `${apiUrl}/api/favicon${queryString ? '?' + queryString : ''}`;
  }

  // 기본 파비콘으로 리셋
  resetToDefault(): void {
    const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
    existingFavicons.forEach(favicon => favicon.remove());
    
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = 'image/x-icon';
    favicon.href = '/favicon.ico';
    
    document.head.appendChild(favicon);
    this.currentConfig = {};
  }

  // 테마 변경 감지 및 자동 업데이트
  updateTheme(theme: 'light' | 'dark'): void {
    const newConfig = { ...this.currentConfig, theme };
    this.setCurrentConfig(newConfig);
    this.updateFavicon(newConfig);
  }

  // 알림 개수 업데이트
  updateNotificationCount(count: number): void {
    const newConfig = { ...this.currentConfig, notificationCount: count };
    this.setCurrentConfig(newConfig);
    this.updateFavicon(newConfig);
  }

  private updateFavicon(config: FaviconConfig): void {
    // 실제 파비콘 업데이트 로직은 컴포넌트에서 useDynamicFavicon 훅을 통해 처리
    // 이 메서드는 설정 변경을 알리는 용도
    window.dispatchEvent(new CustomEvent('faviconConfigChanged', { 
      detail: config 
    }));
  }
}

export default FaviconService;
